import { createFileRoute } from "@tanstack/react-router";
import BlueCrossMaInsurance, { config } from "@/pages/BlueCrossMaInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/blue-cross-ma-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Blue Cross MA TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Blue Cross Blue Shield Massachusetts coverage for TMS, SAINT TMS, and SPRAVATO. Benefits verification in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:title",
          content: "Blue Cross MA TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Blue Cross Blue Shield Massachusetts coverage for TMS, SAINT TMS, and SPRAVATO. Benefits verification in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/blue-cross-ma-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/blue-cross-ma-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <BlueCrossMaInsurance />;
}
